const product = {
  product: "Produkto", // translated 
  products: "Mga Produkto", // translated 
  information: "Impormasyon", // translated 
  additionalInformation: "Karagdagang Impormasyon", // translated 
  contactUs: "Makipag-ugnayan sa Amin", // translated 
  contactUsText: "Gusto mo bang i-customize ang iyong tour o may iba pang mga katanungan?", // translated 
  dropUsAnEmail: "Magpadala sa amin ng email", // translated 
  viewLess: "Tingnan nang mas kaunti", // translated 
  viewMore: "Tingnan ang higit pa", // translated 
  less: "mas kaunti", // translated 
  more: "higit pa", // translated 
  highlights: "Mga Highlight", // translated 
  inclusions: "Mga Kasama", // translated 
  exclusions: "Mga Pagbubukod", // translated 
  pleaseWait: "Mangyaring maghintay...", // translated 
  tourType: "Uri ng Paglilibot", // translated 
  search: "Maghanap", // translated 
  available: "Magagamit", // translated 
  availableTours: "Mga Magagamit na Paglilibot", // translated 
  sortBy: "PAG-URI-URI AYON SA", // translated 
  priceLowToHigh: "Presyo: Mababa hanggang Mataas", // translated 
  priceHighToLow: "Presyo: Mataas hanggang Mababa", // translated 
  mostPopular: "Pinakasikat", // translated 
  roomOnly: "Kwarto Lamang", // translated 
  bedAndBreakfast: "Kama at Almusal", // translated 
  halfBoard: "Kalahating Lupon", // translated 
  fullBoard: "Buong Lugar", // translated 
  allInclusive: "Lahat Kasama", // translated 
  viewDetails: "Tingnan ang mga Detalye", // translated 
  close: "Isara", // translated 
  at: "Sa", // At dat, // translated 
  person: "tao", // translated 
  cancellationPolicy: "Patakaran sa Pagkansela", // translated 
  cancellationIs: "ang pagkansela ay", // translated 
  to: "Para sa", // translated 
  bookingRemarks: "Mga Paalala sa Pag-book", // translated 
  totalPrice: "Kabuuang Presyo", // translated 
  back: "Balik", // translated 
  bookNow: "Mag-book Ngayon", // translated 
  minutes: "Minuto", // translated 
  visitDuration: "Tagal ng Pagbisita", // translated 
  itinerary: "Itineraryo", // translated 
  airportToHotel: "Paliparan papuntang Hotel", // translated 
  hotelToAirport: "Hotel papuntang paliparan", // translated 
  details: "mga detalye", // translated 
  servicesDetails: "Mga Detalye ng Serbisyo", // translated 
  services: "Mga Serbisyo", // translated 
  day: "Araw", // translated 
  next: "Susunod", // translated 
  nextStep: "Susunod na Hakbang", // translated 
  skip: "Laktawan", // translated 
  remarks: "Mga Paalala", // translated 
  optional: "opsyonal", // translated 
  guests: "Mga Bisita", // translated 
  payment: "Pagbabayad", // translated 
  pickup: "pickup", // translated 
  featuredPackage: "Itinatampok na Pakete", // translated 
  flights: "Mga Paglipad", // translated 
  accommodation: "Akomodasyon", // translated 
  transfers: "Mga Paglilipat", // translated 
  tours: "Mga Paglilibot", // translated 
  experiences: "Mga Karanasan", // translated 
  featuredTour: "Itinatampok na Paglilibot", // translated 
  From: "Mula sa", // translated 
  Accommodation: "Akomodasyon", // translated 
  approxDuration: "Tinatayang tagal", // translated 
  travellerInformation: "Impormasyon ng Manlalakbay", // translated 
  bookingOverview: "Pangkalahatang-ideya ng Pag-book", // translated 
  checkout: "Pag-checkout", // translated 
  paymentFailed: "Nabigo ang Pagbabayad", // translated 
  paymentSuccess: "Tagumpay sa Pagbabayad", // translated 
  night: "Gabi", // translated 
  nights: "Mga gabi", // translated 
  viewEscapes: "Tingnan ang Pagtakas", // translated 
  viewExperience: "Tingnan ang Karanasan", // translated 
  escapeType: "Uri ng Pagtakas", // translated 
  adultsOnly: "Mga Matanda Lamang", // translated 
  totalDuration: "Kabuuang Tagal", // translated 
  options: "Mga Pagpipilian", // translated 
  departingAirport: "Paalis na Paliparan", // translated 
  childrenAreNotAllowedInThisTour: "Hindi pinapayagan ang mga bata sa tour na ito", // translated 
};


export default product;
